var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ToastRack',{attrs:{"position":_vm.position,"is-static":true}},[_c('Toaster',{attrs:{"local-show":_vm.localShow,"title":_vm.title,"on-close":_vm.onClose,"variant":_vm.variant,"colour":_vm.colour}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }